// Pushes events into GTM's dataLayer for triggers / GA4 conversions.
export const pushEvent = (event, params = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};

// Fires a Spotify Ads Manager pixel event (safely no-ops if pixel unavailable).
export const spdt = (...args) => {
  if (typeof window !== "undefined" && typeof window.spdt === "function") {
    window.spdt(...args);
  }
};

export const newEventId = () =>
  (typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()));

